function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCameraRexOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M18.764 3c.757 0 1.45.428 1.789 1.105L22 7h6a2 2 0 012 2v18a2 2 0 01-2 2H4a2 2 0 01-2-2V9a2 2 0 012-2h6l1.447-2.895A2.002 2.002 0 0113.237 3h5.527zm-5.528 2l-2 4H4v18h24V9h-7.236l-2-4h-5.528zM16 10a7.5 7.5 0 017.5 7.5c0 4.143-3.357 7.5-7.5 7.5a7.499 7.499 0 01-7.5-7.5A7.5 7.5 0 0116 10zm0 2a5.506 5.506 0 00-5.5 5.5c0 3.033 2.467 5.5 5.5 5.5s5.5-2.467 5.5-5.5S19.033 12 16 12z",
    fill: props.color
  }));
}

export default SvgIconCameraRexOutline;